<template>
  <Loader v-if="loading" />
  <div v-else class="content">
    <h1>Pick2SP Schedule</h1>

    <div
      class="margin-top margin-bottom">
      <button
        :disabled="saving"
        v-on:click="update">Save</button>
    </div>

    <table>
      <thead>
        <tr>
          <th>Date</th>
          <th>From</th>
          <th>To</th>
          <th>Orders to pick</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in data">
          <td>{{ row.date }}</td>
          <td>
            <input :disabled="true" type="time" v-model="row.from" />
          </td>
          <td>
            <input :disabled="true" type="time" v-model="row.to" />
          </td>
          <td>
            <input type="number" v-model="row.orders_to_pick" style="width: 80px;" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    loading: false,
    saving: false,
    data: {}
  }),
  methods: {
    load () {
      Vue.$api.get('/pick-2-sp/schedule', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.data = data
      })
    },
    update() {
      Vue.$api.put('/pick-2-sp/schedule', this.data, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => alert('Saved :)')
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
